import { render } from "./DiscountCampaignCreate.vue?vue&type=template&id=010f20a2"
import script from "./DiscountCampaignCreate.vue?vue&type=script&lang=js"
export * from "./DiscountCampaignCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__